/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CollectionItem
 */
export interface CollectionItem {
    /**
     * 
     * @type {string}
     * @memberof CollectionItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionItem
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionItem
     */
    rarity?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionItem
     */
    weight: number;
}

/**
 * Check if a given object implements the CollectionItem interface.
 */
export function instanceOfCollectionItem(value: object): value is CollectionItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    return true;
}

export function CollectionItemFromJSON(json: any): CollectionItem {
    return CollectionItemFromJSONTyped(json, false);
}

export function CollectionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollectionItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'rarity': json['rarity'] == null ? undefined : json['rarity'],
        'weight': json['weight'],
    };
}

export function CollectionItemToJSON(json: any): CollectionItem {
    return CollectionItemToJSONTyped(json, false);
}

export function CollectionItemToJSONTyped(value?: CollectionItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'imageUrl': value['imageUrl'],
        'rarity': value['rarity'],
        'weight': value['weight'],
    };
}

